import { z } from 'zod';
import { requiredString } from '../helpers';
/**
 * HubSpot Create Ticket v1 Configuration Validator
 * Validates HubSpot ticket creation with contact validation
 */
export const Hubspot_Create_Ticket_1_ConfigValidator = z
    .object({
    hubspotConnection: requiredString('HubSpot Connection is required'),
    ticketSubject: requiredString('Ticket Subject is required'),
    pipelineId: requiredString('Pipeline ID is required'),
    pipelineStageId: requiredString('Pipeline Stage ID is required'),
    description: z.string().optional(),
    sourceType: z.string().optional(),
    priority: z.string().nullable().optional(),
    assignedTo: z.string().optional(),
    associatedContactId: z.string().optional(),
    associatedContactPhoneNumber: z.string().optional()
})
    .refine((data) => {
    const hasContactId = data.associatedContactId && data.associatedContactId.trim() !== '';
    const hasContactPhone = data.associatedContactPhoneNumber && data.associatedContactPhoneNumber.trim() !== '';
    return (hasContactId || hasContactPhone) && !(hasContactId && hasContactPhone);
}, {
    path: ['contact'],
    error: 'Please fill in either Contact ID or Contact Phone Number'
});
//# sourceMappingURL=hubspot-create-ticket-1.js.map